"use strict";
import { config } from "./../config";
import axios from 'axios';

export const panelService = {
    getToken,
    getInscritos,
    getInscrito,
    updateInscrito,
    updateInfantil,
    deleteInscripcion,
    unsuscribeCorredor,
    createInvitado,
    obtenerCSV
}

async function getToken( usuario ) {
    const res = axios.post(`${config.api_url}/tokens`, JSON.stringify(usuario),{
        headers: {
            "Content-Type": "application/json",
            "cache-control": "no-cache"
        }
    })
    const rdo = await res
    return rdo
}

async function getInscritos(token) {
    const res = axios.get(`${config.api_url}/panel`, {
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "cache-control": "no-cache"
        }
    })
    const rdo = await res
    return rdo
}

async function getInscrito(carrera, id, token) {
    const res = axios.get(`${config.api_url}/panel/inscrito/${carrera}/${id}`, {
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "cache-control": "no-cache"
        }
    })
    const rdo = await res
    return rdo
}

async function updateInscrito(persona, token) {
    const res = axios.put(`${config.api_url}/panel/inscrito`, JSON.stringify(persona), {
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "cache-control": "no-cache"
        }
    })

    const rdo = await res
    return rdo
}

async function updateInfantil(persona, token) {
    const res = axios.put(`${config.api_url}/panel/infantil`, JSON.stringify(persona), {
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "cache-control": "no-cache"
        }
    })

    const rdo = await res
    return rdo
}

async function deleteInscripcion(idCarrera, id, token) {
    const data = {
        carrera: idCarrera,
        id
    }
    const res = axios.put(`${config.api_url}/panel/borrar`, JSON.stringify(data), {
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "cache-control": "no-cache"
        }
    })

    const rdo = await res
    return rdo
}

async function unsuscribeCorredor(id, token) {
    const data = { id }
    const res = axios.put(`${config.api_url}/panel/equipos/salir`, JSON.stringify(data), {
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "cache-control": "no-cache"
        }
    })

    const rdo = await res
    return rdo
}

async function createInvitado(invitado, token) {
    const res = axios.post(`${config.api_url}/panel/invitado`, JSON.stringify(invitado), {
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "cache-control": "no-cache"
        }
    })

    const rdo = await res
    return rdo
}

async function obtenerCSV(carrera, token) {
    const res = axios.get(`${config.api_url}/panel/csv/${carrera}`, {
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "cache-control": "no-cache"
        }
    })
    const rdo = await res
    return rdo
}
